exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".yJom5ztj_9YYwBlB0bgnH .ms-Toggle-label{font-weight:400}", ""]);
// Exports
exports.locals = {
	"allDayToggle": "yJom5ztj_9YYwBlB0bgnH"
};